var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDebank = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 452 512",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M439.8 357.7c0 79.8-65.7 144.6-146.7 144.6H15.9V405.9H293.1c27 0 48.9-21.6 48.9-48.2s-21.9-48.2-48.9-48.2H195.3V213.1h97.8c27 0 48.9-21.6 48.9-48.2s-21.9-48.2-48.9-48.2H15.9V20.4H293.1c81 0 146.7 64.7 146.7 144.6c0 37-14.1 70.8-37.4 96.4c23.2 25.6 37.4 59.4 37.4 96.4zM15.9 405.9H254c-50.6 58.5-131.1 96.4-221.8 96.4c-5.5 0-10.9-.1-16.3-.4v-96zm287.9-96.4H211.6V213.1h92.3c3.6 15.6 5.5 31.7 5.5 48.2s-1.9 32.6-5.5 48.2zM254 116.8H15.9v-96c5.4-.3 10.8-.4 16.3-.4c90.7 0 171.2 37.9 221.8 96.4zM15.9 20.4c135.1 0 244.6 107.9 244.6 240.9s-109.5 240.9-244.6 240.9V405.9c81 0 146.7-64.7 146.7-144.6s-65.7-144.6-146.7-144.6V20.4z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDebank, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/debank.02e63325.svg";
export { ForwardRef as ReactComponent };